import {useEffect, useState} from 'react'

// Bootstrap's lg breakpoint — where the header has room for the page title and the page actions.
const DESKTOP_QUERY = '(min-width: 992px)'

/**
 * True from the lg breakpoint up. The page title and the page actions render in the header on
 * desktop and at the top of the content below it; this picks ONE place, so neither is mounted twice
 * (a CSS-hidden second copy would still run its effects and duplicate any stateful action).
 */
export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches)

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY)
    const onChange = (e: MediaQueryListEvent) => setIsDesktop(e.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isDesktop
}
